export default [
  ['Ciudad de México', 'CX'],
  ['Aguascalientes', 'AG'],
  ['Baja California', 'BC'],
  ['Baja California Sur', 'BS'],
  ['Campeche', 'CM'],
  ['Coahuila', 'CO'],
  ['Colima', 'CL'],
  ['Chiapas', 'CS'],
  ['Chihuahua', 'CH'],
  ['Durango', 'DG'],
  ['Guanajuato', 'GT'],
  ['Guerrero', 'GR'],
  ['Hidalgo', 'HG'],
  ['Jalisco', 'JC'],
  ['Estado de Mexico', 'EM'],
  ['Michoacán', 'MI'],
  ['Morelos', 'MO'],
  ['Nayarit', 'NA'],
  ['Nuevo Leon', 'NL'],
  ['Oaxaca', 'OA'],
  ['Puebla', 'PU'],
  ['Queretaro', 'QT'],
  ['Quintana Roo', 'QR'],
  ['San Luis Potosi', 'SL'],
  ['Sinaloa', 'SI'],
  ['Sonora', 'SO'],
  ['Tabasco', 'TB'],
  ['Tamaulipas', 'TM'],
  ['Tlaxcala', 'TL'],
  ['Veracruz', 'VE'],
  ['Yucatan', 'YU'],
  ['Zacatecas', 'ZA'],
];
